/*
 * 报告与报告模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取报告的合同信息
    getContractList(data) {
        // return get('/app/original_report/contract', data)
        return get('/wx/planReport/findPlanReport', data, 'javaHost')
    },
    // 获取报告的列表信息
    getReportList(data) {
        // return get('/app/original_report', data)
        return get('/wx/planReport/getPlanReport', data, 'javaHost')
    },
    // 获取报告的 详情信息
    getReportDetail(data) {
        // return get('/app/original_report', data)
        return get('/planReport/getDetails', data, 'javaHost')
    },

    // 新增报告
    addReport(data) {
        // return post('/app/original_report', data)
        return post('/planReport/savePlanReport', data, 'javaHost')
    },

    // 编辑报告
    updateReport(data) {
        // return put('/app/original_report', data)
        return post('/planReport/editPlanReport', data, 'javaHost')
    },

    // 删除报告
    deleteReport(data) {
        // return del('/app/original_report', data)
        return get('/planReport/delPlanReport', data, 'javaHost')
    },

}



// WEBPACK FOOTER //
// ./src/api/modules/ems/report.js